<template>
  <el-drawer
    title="推荐进阶赋能型文案"
    :visible.sync="visible"
    direction="rtl"
    size="500px"
    append-to-body
    @close="handleClose"
  >
    <div
      class="ai-content-list"
      v-loading="loading"
    >
      <div
        v-for="(item, index) in contentList"
        :key="index"
        :class="['ai-content-item', { selected: selectedIndexes.includes(index) }]"
        @click="toggleSelect(index)"
      >
        <el-checkbox
          :value="selectedIndexes.includes(index)"
          @change="toggleSelect(index)"
        ></el-checkbox>
        <div class="ai-content-text">{{ item }}</div>
      </div>
      <div
        v-if="!loading && contentList.length === 0"
        class="empty-tip"
      >
        暂无推荐文案
      </div>
    </div>
    <div class="drawer-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        @click="handleConfirm"
        :disabled="selectedIndexes.length === 0"
        >确认</el-button
      >
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: 'AiTextDrawer',
  model: {
    prop: 'show',
    event: 'update',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contentList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedIndexes: [],
    };
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update', val);
      },
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.selectedIndexes = [];
      }
    },
  },
  methods: {
    toggleSelect(index) {
      const idx = this.selectedIndexes.indexOf(index);
      if (idx > -1) {
        this.selectedIndexes.splice(idx, 1);
      } else {
        this.selectedIndexes.push(index);
      }
    },
    handleConfirm() {
      const selectedContents = this.selectedIndexes.map((i) => this.contentList[i]);
      this.$emit('confirm', selectedContents);
      this.handleClose();
    },
    handleClose() {
      this.visible = false;
      this.selectedIndexes = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-content-list {
  padding: 0 20px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;

  .ai-content-item {
    display: flex;
    align-items: flex-start;
    padding: 12px;
    border: 1px solid #e4e4e4;
    border-radius: 4px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      border-color: #409eff;
    }

    &.selected {
      border-color: #409eff;
      background-color: #ecf5ff;
    }

    .el-checkbox {
      margin-right: 10px;
      margin-top: 2px;
    }

    .ai-content-text {
      flex: 1;
      line-height: 1.6;
      color: #333;
    }
  }

  .empty-tip {
    text-align: center;
    color: #999;
    padding: 40px 0;
  }
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 20px;
  border-top: 1px solid #e4e4e4;
  background: #fff;
  text-align: right;
}
</style>
